import { render, staticRenderFns } from "./EditFlight.vue?vue&type=template&id=284c8b00&"
import script from "./EditFlight.vue?vue&type=script&lang=js&"
export * from "./EditFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports